module.exports = __webpack_public_path__ + "static/media/favicon.91d65ce8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/regscoaches/favicon.png
// module id = 840
// module chunks = 0